import { render, staticRenderFns } from "./ProductPriceTypes.vue?vue&type=template&id=5cb8c418&scoped=true&lang=html"
import script from "./ProductPriceTypes.vue?vue&type=script&lang=js"
export * from "./ProductPriceTypes.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceTypes.vue?vue&type=style&index=0&id=5cb8c418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb8c418",
  null
  
)

export default component.exports